export const DRAWING_GAME = {
    minPlayers: 2,
    maxPlayers: 8,
    maxSpectators: 40,
    rounds: 3,
    countdownMs: 5_000,
    roundMs: 60_000,
    resultMs: 10_000,
    reconnectGraceMs: 20_000,
    drawerReconnectGraceMs: 8_000,
    abandonedSessionMs: 2 * 60_000,
    maxSessions: 8,
    maxStrokePoints: 32,
    maxStrokeChunks: 1_200,
    strokeRatePerSecond: 35,
    guessRateMs: 700,
};
